import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { SendMoneyService } from 'src/app/dashboard/send-money/send-money.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-cad-to-php',
  templateUrl: './cad-to-php.component.html',
  styleUrls: ['../homepage.component.scss']
})
export class CadToPhpComponent implements OnInit {
  source="cad"
  destination=174
  destination_currency="php"
  transactionFees="0.00"
  conversionRate="0.00"
  amount
  convertedAmount
  countryName = "Canada"
  destinationCountryName = "Philippines"
  screen_width
  offer
  constructor(public http:HttpClient, public sendMoneyService : SendMoneyService, public common : CommonService) { }

  ngOnInit(): void {
    
    this.onSourceChange(this.source,this.countryName)
    this.screen_width = screen.width
    this.common.getOffers().subscribe(res => {
      this.offer = res
    })
  }
  getConversionRate(source_currency, country_id) {
    /* /api/get-exchange-rate?source_currency=cad&country_id=kes&source_amount=1 */
    return this.http.get(environment.api_link + '/api/get-exchange-rate?source_currency=' + source_currency + "&country_id=" + country_id + "&source_amount=1")
  }
  // getTransactionFees(source_currency, destination_currency) {
  //   /*   source_currency="usd"
  //     destination_currency="kes" */
  //   /* /api/get-exchange-rate?source_currency=cad&destination_currency=kes&source_amount=1 */
  //   //console.log(source_currency, destination_currency)
  //   return this.http.get(environment.api_link + '/api/get-exchangeRate-fees?source_currency=' + source_currency + "&destination_currency=" + destination_currency + "&source_amount=1")
  // }
  onSourceChange(sourceCurrency,sourceCountry){
    this.source=sourceCurrency
    this.countryName = sourceCountry
    if(this.source && this.destination){
      this.getConversionRate(this.source,this.destination).subscribe((res:any)=>{
        if(res.return){
          this.conversionRate=res.data.currency_conversion_rate
          this.sendMoneyService.getTransactionFees(this.source,this.destination_currency, this.amount>0?this.amount:1).subscribe((res:any)=>{
            if(res){
              this.transactionFees= res.fee
              this.onAmountChange(this.amount)
            }
          })
        }
      })

    }
  }
  onDestinationChange(destinationCurrency, destinationCountry, desinationCountryId){
    this.destination = desinationCountryId

    this.destination_currency=destinationCurrency
    this.destinationCountryName = destinationCountry
    if(this.source && this.destination){
      this.getConversionRate(this.source,this.destination).subscribe((res:any)=>{
        if(res.return){
          this.conversionRate=res.data.currency_conversion_rate
          this.sendMoneyService.getTransactionFees(this.source,this.destination_currency, this.amount>0?this.amount:1).subscribe((res:any)=>{
            if(res){
              this.transactionFees= res.fee
              this.onAmountChange(this.amount)
            }
          })
        }
      })

    }
  }
  onAmountChange(amount){
    this.amount=parseFloat(amount)
    this.convertedAmount=(this.amount)*parseFloat(this.conversionRate) //-parseFloat(this.transactionFees)
    this.convertedAmount=this.convertedAmount.toFixed(2)
    this.sendMoneyService.getTransactionFees(this.source, this.destination_currency, this.amount>0?this.amount:1).subscribe((res:any)=>{
      if(res){
        this.transactionFees= res.fee

      }
    })
  }

}

